export const FINGER_PRINT_PUBLIC_KEY_META = {
  /** OS-下载中心-下载 */
  DOWNLOAD_CENTER:
    'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCR+pSK2BxcPstCC1N+qrqXudw7wxOYXsjbONG0wV2hurKGUmidnmk/Wu4lw9fS6IPkKQlv7EeQM3H8Dkv9bXrEJ+vnxDn2RjzkVtcxjaevQYfRFH0BlQ9/IuqqKsPSkSgX6ovVJKOkMI4kbmKxoaYmYNd2Uy332qisNFqf4AC0XwIDAQAB',
  /** OS-发货管理 - 退货单管理-打印面单 */
  REFUND_PRINT_LABEL:
    'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCo324BOmjEb7DlKKVnh8b1kupckQyGfa8Gb+BY8Yf6+cxx8ve6DOcaMcbeT2l27hJXKMdh42aeVgqyqLlouWLjyHwEnx3V6u3VwhrexWgiphbZ1P05UDQwm/9Fz8hJQL+EJCpvWX4e8kVxUwRn0WEBkMUF+YP72d1g5siJe7REMQIDAQAB',
  /**OS-发货管理 - 运单管理-打印面单 */
  LOGISTICS_PRINT_LABEL:
    'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQC0o5zBTOZQWwNuujwHbsd9faYANU6Hjr7kFtK7nhpZGttWjx9PHcNzd6LPqd8Dh4pOWuMOJMWOOU91gOSoJPRuyWI82IJpXN59IxjNhdMX3NyXEsEW6k3PT8+LrnALTgCNU+VFivCuyYw5LoghXHxUZiET2X9gcjUoqFqmtSzBnQIDAQAB',
  /**OS-发货管理 - 订单管理-打印捡货单 */
  ORDER_PRINT_PICK_UP_LIST:
    'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCudADYECp/Y5x92lkWxxq3wUC7SeVAydvb/mj0lDpr9ijS5EKAIjsvrC67FO1JugwQXz9ylSfHt8WXrtNrhV6uySN5PFFFjhvK7FPShuQ1SBXl5/QfnWUfRr6pfXhvcs75E2x5CE03T8UWygdk7n0PZUwTpb3w0Pdyzfv8csJzAwIDAQAB',
  /**OS-发货管理 - 订单管理-打印发票 */
  ORDER_PRINT_INVOICE:
    'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCFF9y0+/B1fPZG8EbEZM7gMHrSQ0TsDSxVP3oUQOYnLEWtE4GhLU6ysfLbMdB7cOJdB7xpAnLa7I7HatuU9dKX252xkfZQ853IZEnlxHAP6oS/YzmUwodTF8GYm1xN6pre5rFYtRzFaLg+Hlzpgz6gIVoDtamW9QMdWxiaXke+kQIDAQAB',
  /**OS-发货管理 - 订单管理-打印面单 */
  ORDER_PRINT_LABEL:
    'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQDsbK2x6BLqeL+WNTo9v0/Gvx6lEhxWVSHctUmuBvS8UG7lYLZ7EfsSUuwvexJUbVy7m3ZRUOEe4C3Sp5dpE5LHlMwh2TtM6GTIIx/fsSqGKFWT8YcbALOeOyJ3wJitEmlth7mX2yTOn/3nRYpZcPPlri0UYEc59/5jbqaBLq3hAwIDAQAB',
  PICKUP_PRINT_LABEL:
    'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQC1NfRBXeQLqFKZ4z4jQvUHq3GDkcTx/TF5yJDNLUkacWcWajV2X3oCnFY8iZco5mZD7ScR1KtE7HU9gQ354KNsnuTqKzr+XYiO/xilDbHEvwMhXuoo42cyLnVoJN8JOCqGY3nx8eSauEHbBzby5slzC0oIlsruMas85x/0BZ1WiQIDAQAB',
}

export const CAPTCHA_SCENE = {
  /**OS-下载中心-下载 */
  DOWNLOAD_CENTER: 'LgOsDcD',
  /**OS-发货管理 - 退货单管理-打印面单 */
  REFUND_PRINT_LABEL: 'LgOsGtnPtlsE',
  /**OS-发货管理 - 运单管理-打印面单 */
  LOGISTICS_PRINT_LABEL: 'LgOsWbPtlsE',
  /**OS-发货管理 - 订单管理-打印捡货单 */
  ORDER_PRINT_PICK_UP_LIST: 'LgOsOdPtpulE',
  /**OS-发货管理 - 订单管理-打印发票 */
  ORDER_PRINT_INVOICE: 'LgOsOdIpE',
  /**OS-发货管理 - 订单管理-打印面单 */
  ORDER_PRINT_LABEL: 'LgOsOdPtlsE',
  /**os-捡货管理-打印面单 */
  PICKUP_PRINT_LABEL: 'LgOsIMPtlsE',
}

export const CAPTCHA_TYPE_META = {
  /**OS-下载中心-下载 */
  downloadCenter: 'DOWNLOAD_CENTER',
  /**OS-发货管理 - 退货单管理-打印面单 */
  refundPrintLabel: 'REFUND_PRINT_LABEL',
  /**OS-发货管理 - 运单管理-打印面单 */
  logisticsPrintLabel: 'LOGISTICS_PRINT_LABEL',
  /**OS-发货管理 - 订单管理-打印捡货单 */
  orderPrintPickUplist: 'ORDER_PRINT_PICK_UP_LIST',
  /**OS-发货管理 - 订单管理-打印发票 */
  orderPrintInvoice: 'ORDER_PRINT_INVOICE',
  /**OS-发货管理 - 订单管理-打印面单 */
  orderPrintLabel: 'ORDER_PRINT_LABEL',
  /**os-捡货管理-打印面单 */
  pickupPrintLabel: 'PICKUP_PRINT_LABEL',
}
